/*!

=========================================================
* Argon Dashboard React - v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Index from "views/Index.js";
import Profile from "views/Profile.js";
import Register from "views/auth/Register.js";
import Login from "views/auth/Login.js";
import WalletTransactions from "views/WalletTransactions.js";
import ForgotPassword from "views/auth/ForgotPassword";
import Setting from "views/Setting";
import TicketHolder from "views/TicketHolder";
import SchoolFans from "views/SchoolFans";
import SchoolAthletes from "views/SchoolAthletes";
import ChangeAdminRequests from "views/ChangeAdminRequests";
import RegisterAsCollective from "views/auth/RegisterAsCollective";
import SubAdmin from "views/SubAdmin";
import PizzaMoney from "views/PizzaMoney";
import AdExchange from "views/AdExchange";
import AthleteIdsForContest from "views/AthleteIdsForContest";
import ManagerTech from "views/ManagerTech";
import Advertisement from "views/Advertisement";
import ManagerHelper from "views/ManagerHelper";
import Contests from "views/Contests";
import Notifications from "views/Notifications";
import SportsCommunityBadge from "views/SportsCommunityBadge";

var routes = [
  // **************School layouts*****************
  {
    path: "/index",
    name: "Dashboard",
    icon: "ni ni-tv-2 text-primary",
    component: Index,
    layout: "/school",
    subAdmin: true,
  },
  {
    path: "/ip-contract",
    name: "IP CONTRACT",
    icon: "ni ni-bullet-list-67 text-red",
    component: WalletTransactions,
    layout: "/school",
    subAdmin: true,
  },
  {
    path: "/pizza-money",
    name: "PIZZA MONEY ",
    icon: "ni ni-bullet-list-67 text-red",
    component: PizzaMoney,
    layout: "/school",
    subAdmin: true,
    tooltip:
      "YOU CAN HELP HUNGRY ATHLETES + THEIR FAMILIES BY JOINING PIZZA MONEY PILOT PROGRAM AT FHP",
  },
  {
    path: "/manager-teach",
    name: "REQUEST MANAGER TEACH",
    icon: "ni ni-tv-2 text-primary",
    component: ManagerTech,
    layout: "/school",
    subAdmin: true,
  },
  {
    path: "/manager-request",
    name: "Manager REQUEST",
    icon: "ni ni-tv-2 text-primary",
    component: ManagerHelper,
    layout: "/school",
    subAdmin: true,
  },
  // {
  //   path: "/ticket-holder",
  //   name: "Ticket Holder",
  //   icon: "ni ni-tv-2 text-primary",
  //   component: TicketHolder,
  //   layout: "/admin",
  //   subAdmin: true,
  // },
  // {
  //   path: "/user-profile",
  //   name: "User Profile",
  //   icon: "ni ni-single-02 text-yellow",
  //   component: Profile,
  //   layout: "/admin",
  // },

  {
    path: "/setting",
    name: "Setting",
    icon: "ni ni-settings-gear-65 text-primary",
    component: Setting,
    layout: "/school",
    subAdmin: true,
  },
  {
    path: "/message-fans",
    name: "MESSAGE FHP FANS",
    icon: "ni ni-settings-gear-65 text-primary",
    component: SchoolFans,
    layout: "/school",
    subAdmin: true,
  },
  {
    path: "/home-page-button",
    name: "Hm Pg Buttons",
    icon: "ni ni-settings-gear-65 text-primary",
    component: SchoolAthletes,
    layout: "/school",
    subAdmin: true,
    tooltip: "YOUR ATHLETES WILL LEARN MORE WAYS TO MONETIZE THEIR BRANDS",
  },
  {
    path: "/change-admin-requests",
    name: "Change Admin Requests",
    icon: "ni ni-settings-gear-65 text-primary",
    component: ChangeAdminRequests,
    layout: "/school",
    subAdmin: false,
  },
  {
    path: "/athlete-id-for-contest",
    name: "COACH UPLOADS CONTEST IDs",
    icon: "ni ni-tv-2 text-primary",
    component: AthleteIdsForContest,
    layout: "/school",
    subAdmin: true,
  },
  {
    path: "/school-user",
    name: "School Users",
    icon: "ni ni-settings-gear-65 text-primary",
    component: SubAdmin,
    layout: "/school",
    subAdmin: false,
  },
  {
    path: "/notifications",
    name: "Notifications",
    icon: "ni ni-settings-gear-65 text-primary",
    component: Notifications,
    layout: "/school",
    subAdmin: false,
  },
  {
    path: "/ad-exchange",
    name: "Ad Exchange",
    icon: "ni ni-settings-gear-65 text-primary",
    component: AdExchange,
    layout: "/school",
  },
  {
    path: "/contests",
    name: "Contests",
    icon: "ni ni-settings-gear-65 text-primary",
    component: Contests,
    layout: "/school",
  },
  {
    path: "/ad-exchange",
    name: "BENEFITS OF AD EXCHANGE",
    icon: "ni ni-settings-gear-65 text-primary",
    component: AdExchange,
    layout: "/school",
  },
  {
    path: "/advertisement",
    name: "UPLOAD FHP ADVERTISEMENTS ",
    icon: "ni ni-tv-2 text-primary",
    component: Advertisement,
    layout: "/school",
    subAdmin: true,
  },
  {
    path: "/sports-community-badge",
    name: "FHP Sports Community Badge",
    icon: "ni ni-tv-2 text-primary",
    component: SportsCommunityBadge,
    layout: "/school",
    subAdmin: true,
  },
  // ***************collective*****************
  {
    path: "/index",
    name: "Dashboard",
    icon: "ni ni-tv-2 text-primary",
    component: Index,
    layout: "/collective",
    subAdmin: true,
  },
  {
    path: "/athlete-id-for-contest",
    name: "SUBMIT ATHLETE ID#S - CONTEST",
    icon: "ni ni-tv-2 text-primary",
    component: AthleteIdsForContest,
    layout: "/collective",
    subAdmin: true,
  },
  {
    path: "/manager-tech",
    name: "REQUEST MANAGER TEACH",
    icon: "ni ni-tv-2 text-primary",
    component: ManagerTech,
    layout: "/collective",
    subAdmin: true,
  },
  {
    path: "/manager-request",
    name: "Manager REQUEST",
    icon: "ni ni-tv-2 text-primary",
    component: ManagerHelper,
    layout: "/collective",
    subAdmin: true,
  },
  {
    path: "/advertisement",
    name: "UPLOAD FHP ADVERTISEMENTS ",
    icon: "ni ni-tv-2 text-primary",
    component: Advertisement,
    layout: "/collective",
    subAdmin: true,
  },
  {
    path: "/Wallet-transactions",
    name: "Wallet Transactions",
    icon: "ni ni-bullet-list-67 text-red",
    component: WalletTransactions,
    layout: "/collective",
    subAdmin: true,
  },
  {
    path: "/pizza-money",
    name: "PIZZA MONEY",
    icon: "ni ni-bullet-list-67 text-red",
    component: PizzaMoney,
    layout: "/collective",
    subAdmin: true,
    tooltip:
      "YOU CAN HELP HUNGRY ATHLETES + THEIR FAMILIES BY JOINING PIZZA MONEY PILOT PROGRAM AT FHP",
  },
  {
    path: "/setting",
    name: "Setting",
    icon: "ni ni-settings-gear-65 text-primary",
    component: Setting,
    layout: "/collective",
    subAdmin: true,
  },
  {
    path: "/fans",
    name: "MESSAGE FHP FANS",
    icon: "ni ni-settings-gear-65 text-primary",
    component: SchoolFans,
    layout: "/collective",
    subAdmin: true,
    tooltip: "YOU'LL RECRUIT MORE DONORS BY MESSAGING FHP REGISTERED FANS",
  },
  {
    path: "/athletes",
    name: "Hm Pg Buttons",
    icon: "ni ni-settings-gear-65 text-primary",
    component: SchoolAthletes,
    layout: "/collective",
    subAdmin: true,
    tooltip:
      "THE IP CONTRACT YOU SIGN HERE WILL HELP YOUR ATHLETES MONETIZE THEIR BRANDS",
  },
  {
    path: "/sports-community-badge",
    name: "FHP Sports Community Badge",
    icon: "ni ni-settings-gear-65 text-primary",
    component: SportsCommunityBadge,
    layout: "/collective",
    subAdmin: true,
  },
  {
    path: "/change-admin-requests",
    name: "Change Admin Requests",
    icon: "ni ni-settings-gear-65 text-primary",
    component: ChangeAdminRequests,
    layout: "/collective",
    subAdmin: false,
  },
  {
    path: "/collective-user",
    name: "Collective Users",
    icon: "ni ni-settings-gear-65 text-primary",
    component: SubAdmin,
    layout: "/collective",
    subAdmin: false,
  },

  {
    path: "/ad-exchange",
    name: "BENEFITS OF AD EXCHANGE",
    icon: "ni ni-settings-gear-65 text-primary",
    component: AdExchange,
    layout: "/collective",
  },

  // ******************auth******************
  {
    path: "/login",
    name: "Login",
    icon: "ni ni-key-25 text-info",
    component: Login,
    layout: "/auth",
    isMenu: false,
  },
  {
    path: "/forgot-password",
    name: "Forgot Password",
    icon: "ni ni-key-25 text-info",
    component: ForgotPassword,
    layout: "/auth",
    isMenu: false,
  },
  {
    path: "/register-school",
    name: "Register",
    icon: "ni ni-circle-08 text-pink",
    component: Register,
    layout: "/auth",
    isMenu: false,
  },
  {
    path: "/register-collective",
    name: "Register",
    icon: "ni ni-circle-08 text-pink",
    component: RegisterAsCollective,
    layout: "/auth",
    isMenu: false,
  },
];
export default routes;
